import { active } from "@api/stores/customers/active/path";
import { deactive } from "@api/stores/customers/deactive/path";
import { salesInvoices } from "@api/stores/customers/salesInvoices/path";
import { sendMessage } from "@api/stores/customers/sendMessage/path";
import { stats } from "@api/stores/customers/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/`;
const pathById = `${pathBase}:customerId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const customers = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  stats,
  sendMessage,
  salesInvoices,
};
